/* eslint-disable react/jsx-props-no-spreading */
import { Button as ChromaButton } from '@iag-packages/chroma-react/lib/components';
import React from 'react';
import styled from 'styled-components';
import THEME from 'theme';

const ButtonWrapper = styled.div<{ align: string }>`
  .c-btn:disabled {
    opacity: 0.2;
  }

  .c-btn--secondary {
    &:active {
      border: 2px solid ${THEME.FIELD.BORDER.DARK};
      background-color: transparent !important;
    }

    border-color: ${THEME.FIELD.BORDER.DEFAULT} !important;
    color: ${THEME.TEXT.BODY};
  }

  .c-btn--tertiary {
    padding: 0;
  }

  .c-btn--link {
    color: ${THEME.LINK.DEFAULT} !important;
    text-align: ${({ align }) => align || 'left'};

    &:active {
      background-color: transparent !important;
    }
  }
`;

export const Button = ({ ...props }) => {
  const { align } = props;
  return (
    <ButtonWrapper align={align}>
      <ChromaButton {...props} />
    </ButtonWrapper>
  );
};

export default Button;
